import React from 'react';
import { IdeasSection } from '../initiatives/IdeasSection';
export function HomeInitiatives() {
  return <IdeasSection id="projects" title="Projects Powered by SyNeural" body="Explore projects applying SyNeural’s connected knowledge and human capability systems to new challenges." link={{
    label: 'View All Projects',
    href: '/projects'
  }} data-id="element-402" data-mp="3lkojt3q27j16" />;
}